
//养生，  健康，    育儿，      金融，   医疗，    美食，   风景，    旅游，  护发，      美妆，  体育，  减肥
//Health, Healthy, Parenting, Finance, Medical, Food,   Scenery, Travel, Hair Care, Beauty, Sports, Weight Loss


const dataJSON = [
  // {
  //   id: "1",
  //   game_name: "European Food Art · Italian Fruit and Vegetable Boutique: Gifts Originating from the Land of Italy",
  //   class:'Food',
  //   img:'../image/1.png'
  // },
  // {
  //   id: "2",
  //   game_name: "Should gallbladder polyps that cause headaches be removed or not? Beyond this size, there is a high risk of malignant transformation",
  //     class:'Health',
  //      img:'../image/2.png'

  // },
  // {
  //   id: "3",
  //   game_name: "After the age of 50, cerebral infarction is more likely to affect these four types of people. Check if you are one of them. When people reach the age of 50, various diseases will come to them.",
  //     class:'Health',
  //      img:'../image/3.png'

  // },
  // {
  //   id: "4",
  //   game_name: "How to set and achieve exercise goals? What is the source of motivation for healthy exercise in life?",
  //     class:'Sports',
  //      img:'../image/4.png'
  // },
  // {
  //   id: "5",
  //   game_name: "A child's increasing success is usually due to their parents doing three things right",
  //     class:'Parenting',
  //      img:'../image/5.png'
  // },
  // {
  //   id: "6",
  //   game_name: "Parents who are not anxious or consumed internally have these six words as their parenting magic weapon",
  //     class:'Parenting',
  //      img:'../image/6.png'
  // },
  // {
  //   id: "7",
  //   game_name: "Philosophy | The Best Way to Manage Health",
  //     class:'Healthy',
  //      img:'../image/7.png'
  // },
  {
    id: "8",
    game_name: "Reasonable diet is the first hurdle of a healthy life",
      class:'Healthy',
       img:'../image/8.png'
  },
  {
    id: "9",
    game_name: "The Past Forward: Neuroscience's Contributions to Current Therapies",
      class:'Medical',
       img:'../image/9.png'
  },
  {
    id: "10",
    game_name: "Memory 'collapse' caused by too much stress may be related to a kind of mental illness.e",
      class:'Healthy',
       img:'../image/10.png'
  },
  {
    id: "11",
    game_name: "The 'last week' of the menstrual period is an accelerated period for women to lose fat.",
      class:'Weight Loss',
       img:'../image/11.png'
  },
  {
    id: "12",
    game_name: "How do young people nowadays maintain their health?",
      class:'Health',
       img:'../image/12.png'
  },
  {
    id: "13",
    game_name: "When did you suddenly realize that physical health is the most important thing?",
      class:'Healthy',
       img:'../image/13.png'
  },
  {
    id: "14",
    game_name: "How to break through in the global market for 'girlish' makeup with floral awareness",
      class:'Beauty',
       img:'../image/14.png'
  },
  {
    id: "15",
    game_name: "Google, Microsoft's Medical Evolution History: Billions of Investment, Extinction and Rebirth",
      class:'Medical',
       img:'../image/15.png'
  },
  {
    id: "16",
    game_name: "A healthy lifestyle can effectively help you reduce cardiovascular risk",
      class:'Healthy',
       img:'../image/16.png'
  },
  {
    id: "17",
    game_name: " Asian style tiger mothers who disdain the bottom of the chain are becoming popular in the American parenting circle",
      class:'Parenting',
       img:'../image/17.png'
  },
  {
    id: "18",
    game_name: "Three Western Cuisine | Make Delicious Dishes with Different Styles, Don't Repeat Every Day, Experience Different Flavors",
      class:'Food',
       img:'../image/18.png'
  },
  {
    id: "19",
    game_name: "Beauty | Beauty Tips, Beauty Beginners Become Beauty Experts in seconds",
      class:'Beauty',
       img:'../image/19.png'
  },
  {
    id: "20",
    game_name: "How to take care of hair? Daily hair care methods!",
      class:'Hair Care',
       img:'../image/20.png'
  },
  {
    id: "21",
    game_name: "Travel Tips | Travel Tips for Newcomers",
      class:'Travel',
       img:'../image/21.png'
  }, 
   {
    id: "22",
    game_name: "A popular maple viewing destination in Canada! Autumn is strong, maple leaves are red! Missed waiting for a year!",
      class:'Scenery',
       img:'../image/22.png'
  },
  {
    id: "23",
    game_name: "Medical Knowledge Popularization - Types of Cells",
      class:'Medical',
       img:'../image/23.png'
  },
  {
    id: "24",
    game_name: "Understand children and communicate effectively",
      class:'Parenting',
       img:'../image/24.png'
  },
  {
    id: "25",
    game_name: "【 Health Science Popularization 】 Daily Life Tips",
      class:'Healthy',
       img:'../image/25.png'
  },
  {
    id: "26",
    game_name: "The four health secrets of Japan, the world's oldest country, are worth learning from",
      class:'Healthy',
       img:'../image/26.png'
  },
  {
    id: "27",
    game_name: "Before entering the Dutch market, understand these financial knowledge first!",
      class:'Finance',
       img:'../image/27.png'
  },
  {
    id: "28",
    game_name: "Travel articles | About tourism",
      class:'Travel',
       img:'../image/28.png'
  },
  {
    id: "29",
    game_name: "Global cuisine: 5 most famous street snacks, take you on a global journey!",
      class:'Food',
       img:'../image/29.png'
  },
  {
    id: "30",
    game_name: " How to take care of hair? Daily hair care methods!",
      class:'Hair Care',
       img:'../image/30.png'
  },
 
]

export function getDataList() {
    return dataJSON
}
  
  